export default "__VITE_PUBLIC_ASSET__0843439f__"